import { OnionMiddleware } from 'umi-request';
import { getMarkingApiData, logMarkingApi } from '@/utils/log/logWithOriginUrl';
/**
 * 中间件 切换mock 测试 生产的域名
 * mock 就请求本地的mock
 */
const addPageMarkData: OnionMiddleware = async (ctx, next) => {
  try {
    logMarkingApi(ctx.req.url, ctx.req.options.method);

    const data = getMarkingApiData(ctx.req.url, ctx.req.options.method);

    if (data && ctx.req.options.method?.toLowerCase() === 'post') {
      ctx.req.options.data = { ...ctx.req.options.data, ...data };
    }
    if (data && ctx.req.options.method?.toLowerCase() === 'get') {
      ctx.req.options.params = { ...ctx.req.options.params, ...data };
    }
  } catch {
    // do nothing
  }

  await next();
};
export default addPageMarkData;
